import { render, staticRenderFns } from "./UnitDropdown.vue?vue&type=template&id=43bb52f6&scoped=true&"
import script from "./UnitDropdown.vue?vue&type=script&lang=js&"
export * from "./UnitDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UnitDropdown.vue?vue&type=style&index=0&id=43bb52f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bb52f6",
  null
  
)

export default component.exports